import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CommonRoutingModule } from "./common-routing.module";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { EmployeeDashboardComponent } from "./employee-dashboard/employee-dashboard.component";
import { RmSidebarComponent } from "./rm-sidebar/rm-sidebar.component";
import { LoginComponent } from "./login/login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoginService } from "./login/login.service";
import { DeletePopUpComponent } from "./delete-pop-up/delete-pop-up.component";
import { ErrorPopUpComponent } from "./error-pop-up/error-pop-up.component";
import {
  MatSnackBarModule,
  MatAutocompleteModule,
  MatFormFieldModule,
  MatInputModule,
  MatDialogModule,
  MatSelectModule,
} from "@angular/material";
import { UploadHistoryComponent } from "./upload-history/upload-history.component";
import { NgxPaginationModule } from "ngx-pagination";
import { ProfileComponent } from "./profile/profile.component";
import { ProfileService } from "./profile/profile.service";
import { UtilsModule } from "../utils/utils.module";
import { LoaderComponent } from "./loader/loader.component";
import { ConfigService } from "../utils/services/config.service";
import { ConfirmPopUpComponent } from "./confirm-pop-up/confirm-pop-up.component";
import { DeleteEntryPopUpComponent } from "./delete-entry-pop-up/delete-entry-pop-up.component";
import { LeavePopUpComponent } from "./leave-pop-up/leave-pop-up.component";
import { MyDatePickerModule } from "mydatepicker";
import { LandingComponent } from "./landing/landing.component";
import { LandingService } from "./landing/landing.service";
import { VerticalDepartmentPopUpComponent } from "./vertical-department-pop-up/vertical-department-pop-up.component";

@NgModule({
  imports: [
    CommonModule,
    CommonRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatSnackBarModule,
    NgxPaginationModule,
    MyDatePickerModule,
    UtilsModule,
  ],

  declarations: [
    SidebarComponent,
    EmployeeDashboardComponent,
    RmSidebarComponent,
    LoginComponent,
    DeletePopUpComponent,
    ErrorPopUpComponent,
    UploadHistoryComponent,
    ProfileComponent,
    LoaderComponent,
    ConfirmPopUpComponent,
    VerticalDepartmentPopUpComponent,
    LeavePopUpComponent,
    DeleteEntryPopUpComponent,
    LandingComponent,
  ],
  providers: [LoginService, ProfileService, ConfigService, LandingService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    DeletePopUpComponent,
    ErrorPopUpComponent,
    UploadHistoryComponent,
    ConfirmPopUpComponent,
    VerticalDepartmentPopUpComponent,
    LeavePopUpComponent,
    DeleteEntryPopUpComponent,
  ],
  exports: [LoaderComponent],
})
export class AppCommonModule {}



// WEBPACK FOOTER //
// ./src/app/common/common.module.ts